function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKibana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "418.238 121.219 42.4 55",
    width: 42.4,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 419.038 141.819 C 426.338 141.819 433.238 143.719 439.238 146.919 L 460.638 121.219 L 418.238 121.219 L 418.238 172.219 L 418.238 141.819 L 419.038 141.819",
    style: {
      fill: "rgb(233, 71, 139)"
    },
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 439.238 146.919 L 418.238 172.219 L 418.238 176.219 L 460.538 176.219 C 458.138 163.619 450.138 152.919 439.238 146.919",
    style: {
      fill: "rgb(62, 190, 176)"
    },
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 439.238 146.919 L 418.238 172.219 L 418.238 176.219 L 425.738 176.219 L 446.138 151.619 C 446.138 151.619 444.738 150.519 442.838 149.119 C 441.438 148.119 439.238 146.919 439.238 146.919",
    style: {
      fill: "rgb(55, 165, 149)"
    },
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M 419.038 141.819 L 418.238 141.819 L 418.238 172.219 L 439.238 146.919 C 433.238 143.719 426.338 141.819 419.038 141.819",
    style: {
      fill: "rgb(53, 53, 53)"
    },
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKibana);
export default __webpack_public_path__ + "static/media/kibana.73316a9b.svg";
export { ForwardRef as ReactComponent };